import { render } from "./PrivateBookingManagement.vue?vue&type=template&id=9700c05a&scoped=true"
import script from "./PrivateBookingManagement.vue?vue&type=script&lang=js"
export * from "./PrivateBookingManagement.vue?vue&type=script&lang=js"

import "./PrivateBookingManagement.vue?vue&type=style&index=0&id=9700c05a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9700c05a"]])

export default __exports__